import { Component, OnInit } from '@angular/core';
import { OutletRightsDTO } from '../../core/outlet-cache/model/outlet';
import { BaseComponent } from '../../core/helper/base.component';
import { MatDialog } from '@angular/material/dialog';
import { UserDetails } from '../../core/http/auth/model/user';
import { UserCacheService } from '../../core/user/user-cache.service';
import { AuthService } from 'src/app/core/http/auth/auth.service';
import { CountryService } from 'src/app/core/http/country/country.service';
import { OutletPopupComponent } from './outlet-popup/outlet-popup.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent extends BaseComponent implements OnInit {
  outletSelected: boolean = false;
  user: UserDetails = {
    outlets: new Array<OutletRightsDTO>(),
    firstName: '',
    lastName: '',
    username: '',
    languageIso: '',
  };
  userAdminCountries: string[] = [];

  constructor(
    private dialog: MatDialog,
    private countryService: CountryService,
    private userService: UserCacheService,
    private authService: AuthService,
  ) {
    super();
  }

  ngOnInit() {
    if (!this.outletSelected) {
      const dialogRef = this.dialog.open(OutletPopupComponent, {
        width: '500px',
        height: '150px',
        hasBackdrop: true,
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(() => {
        this.outletSelected = true; 
      });
    }
    
    this.getCurrentUser();
    this.countryService
      .getUserAdminCountries()
      .subscribe((countries: string[]) => {
        this.userAdminCountries = countries;
      });
  }

  onSelectOutlet(): void {
    this.outletSelected = true; 
  }

  logout(): void {
    this.authService.logout();
  }

  private getCurrentUser() {
    this.user = this.userService.get();
  }
}
